import React from 'react';
import clsx from 'clsx';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { useIntl } from 'react-intl';
import { validationClasses } from '@/utils/errors';
import { dictionaryFieldTypes } from '@/constants/fields';
import {
  cohortDateTimeValue,
  cohortDateValue,
  cohortTimeValue,
  dateTimePickerFormat,
  parseDateToDateString,
  parseDateToDateTimeString,
  parseDateToTimeTzString,
} from '../datetimeHelper';

const CohortFilterDateTimePicker = ({
  className,
  disabled,
  endDate,
  fieldType = 'date',
  index = 0,
  maxDate,
  minDate,
  onChange,
  placeholder,
  selectsEnd,
  selectsStart,
  startDate,
  validationError,
  values = [],
}) => {
  const intl = useIntl();
  const hasDatePart = () => fieldType === dictionaryFieldTypes.DATE || fieldType === dictionaryFieldTypes.DATETIME;

  const hasTimePart = () => fieldType === dictionaryFieldTypes.DATETIME || fieldType === dictionaryFieldTypes.TIME;

  const selectedValue = (value) => {
    if (fieldType === dictionaryFieldTypes.DATE) {
      return cohortDateValue(value);
    }

    if (fieldType === dictionaryFieldTypes.DATETIME) {
      return cohortDateTimeValue(value);
    }

    if (fieldType === dictionaryFieldTypes.TIME) {
      return cohortTimeValue(value);
    }

    return null;
  };

  const handleDateTimeChange = (date, i) => {
    let valueForState;
    if (fieldType === dictionaryFieldTypes.DATE) {
      valueForState = parseDateToDateString(date);
    }

    if (fieldType === dictionaryFieldTypes.DATETIME) {
      valueForState = parseDateToDateTimeString(date);
    }

    if (fieldType === dictionaryFieldTypes.TIME) {
      valueForState = parseDateToTimeTzString(date);
    }

    const newValues = Array.isArray(values) ? [...values] : [];
    newValues[i] = valueForState;
    onChange(newValues);
  };

  return (
    <DatePicker
      wrapperClassName={clsx('aridhia-cohort-filter-date-time-picker', className)}
      className={validationClasses(validationError, 'aridhia-semantic-input  w-100')}
      fixedHeight
      dateFormat={dateTimePickerFormat(fieldType)}
      selected={selectedValue(values[index])}
      disabled={disabled}
      onChange={(date) => handleDateTimeChange(date, index)}
      showMonthDropdown={hasDatePart()}
      showYearDropdown={hasDatePart()}
      dropdownMode="select"
      showTimeSelect={hasTimePart()}
      showTimeSelectOnly={!hasDatePart()}
      selectsStart={selectsStart}
      selectsEnd={selectsEnd}
      startDate={selectedValue(startDate)}
      minDate={selectedValue(minDate)}
      endDate={selectedValue(endDate)}
      maxDate={selectedValue(maxDate)}
      placeholderText={placeholder || intl.formatMessage({ id: 'cohort.filter.select.placeholder' })}
    />
  );
};

export default CohortFilterDateTimePicker;
